export const gdpr = {
  routes: [
    {
      path: "/physical-storage",
      component: () => import("../organization-physical-storage-view"),
    },
  ],
};
